import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { HttpParams, HttpClient } from '@angular/common/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { TranslateService } from '@ngx-translate/core';
import { Uploads } from '../../../services/uploads';
import { Globals } from '../../../../globals';
import { ImportFinishPage } from '../import-finish/import-finish';

@Component({
  selector: 'page-import-sales',
  templateUrl: 'import-sales.html',
})
export class ImportSalesPage {
  loadingPopup: any;
  list_elements: any = [];
  preview_table: boolean = false;
  payment_type: string = 'select';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public uploadServices: Uploads,
    public globals: Globals,
    public http: HttpClient,
    public afs: AngularFirestore,
    public translate: TranslateService,
    public toast: ToastController) {
  }
  //Create file in firebase
  selectedFiles: FileList;
  xls_ref: any;
  excel_url: any;
  file_type: any;
  file_url: any = '';
  async selectFileXls(event) {
    const file = event.target.files.item(0);

    if (file.type.match('application/vnd.ms-excel.*') || file.type.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.*')) {
      this.selectedFiles = event.target.files;//File selected
      this.xls_ref = await this.uploadServices.uploadCompleteExcel(this.selectedFiles, 'xls') //Upload file to firbase storage
      this.file_type = file.type; //Type of the file
      this.file_url = this.xls_ref; //Name of the file
      event.target.value = '';
      this.checkExcel();

    } else {
      let toast = this.loadingCtrl.create({
        content: this.translate.instant('import-excel-formato-invalido'),
        duration: 3000,
      });
      event.target.value = '';
      toast.present();
    }
  }

  //Check if all fields are filled
  file_name: string;
  found_all: boolean = false;
  measurement_correct: boolean = true;
  checkExcel() {
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('type', this.file_type)
      .set('file_url', this.file_url);
    this.http.post(this.globals.analytics_path + 'import/check_import_sales', params, {})
      .subscribe(async res => {
        this.list_elements = res['list_elements'];
        this.found_all = res['found_all'];
        this.file_name = res['file_name'];
        this.preview_table = true;
      });
  }

  downloadExample() {
    window.location.href = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates_files%2Fplantilla_ventas.xls?alt=media&token=3110cc4a-b173-433d-8da8-f5063e5a134e';
  }

  import() {
    if (this.payment_type != 'select') {
      let loader = this.loadingCtrl.create({
        content: this.translate.instant('import-excel-ventas-importando-ventas'),
        duration: 3000,
      });
      loader.present();
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('file_name', this.file_name)
        .set('waiter', this.globals.user_name)
        .set('waiter_uid', this.globals.user_uid)
        .set('payment_type', this.payment_type);
      this.http.post(this.globals.analytics_path + 'import/import_sales', params, {})
        .subscribe(async res => {
          loader.dismiss();
          this.navCtrl.push(ImportFinishPage, {
            type: 'sales'
          });
        });
    } else {
      let toast = this.toast.create({
        message: this.translate.instant('general-selecciona-metodo-pago'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/components/import-excel/import-sales/import-sales.ts